"use client"

import { LoggerMolecule } from "@/instrumentation/logger/logger-molecule"
import { type EventContext, Flow } from "@/instrumentation/logger/types"
import * as amplitude from "@amplitude/analytics-browser"
import { cn } from "@rarible_int/anaconda_ui_components"
import { useMolecule } from "bunshi/react"
import { useEffect } from "react"

interface ImageSectionProps {
  imageUrl: string
}

interface ImageSectionComponentProps {
  props: ImageSectionProps
  styles?: {
    backgroundColor?: string
    textColor?: string
    padding?: string
    margin?: string
  }
}

export function ImageSection({ props, styles }: ImageSectionComponentProps) {
  const logger = useMolecule(LoggerMolecule)
  const { imageUrl } = props

  useEffect(() => {
    const imageContext: EventContext = {
      sectionType: "image",
      hasImage: (!!imageUrl).toString(),
      flow: Flow.BrandPage,
    }

    logger?.api.pushEvent("Brand image section viewed", imageContext)
    amplitude.track("Brand image section viewed", imageContext)
  }, [imageUrl, logger])

  return (
    <div
      style={{
        backgroundColor: styles?.backgroundColor,
        color: styles?.textColor,
        padding: styles?.padding,
        margin: styles?.margin,
      }}
    >
      <div className="relative w-full">
        <img
          src={imageUrl}
          alt="Brand content"
          className="h-auto w-full rounded-lg object-cover shadow-lg"
          loading="lazy"
          onError={(e) => {
            console.error("Image failed to load:", imageUrl)
            // Optionally set a fallback image
            e.currentTarget.src = "/images/placeholder.webp"
          }}
        />
      </div>
    </div>
  )
}
